import React from 'react';
import PropTypes from 'prop-types';
import { FDBox } from '@facet-wealth/design';
import AdditionalDetailsSection from './AdditionalDetailsSection';

const AdditionalDetailsSections = ({ collection }) => {
  return (
    <>
      {collection.resources().list().map((resource) => (
        <FDBox key={resource.id()} flex={1}>
          <AdditionalDetailsSection resource={resource} />
        </FDBox>
      ))}
    </>
  );
};

AdditionalDetailsSections.propTypes = {
  collection: PropTypes.object.isRequired,
};

AdditionalDetailsSections.defaultProps = {};

export default AdditionalDetailsSections;
